export const onlyLetters = /\p{L}+/u;
export const notOnlyWhitespace = /^(?!\s*$).+/;
export const onlyNumbers = /^[0-9]*$/;
export const countryCode = /^\+\d{1,3}$/;
export const monthDayRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/;
export const dayMonthRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])$/;
export const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
export const usDateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(\d{4})$/;
/**
 * CustomerHub-compatible email regex.
 *   ^([\w\.\-\+]+)@[\w\-]+(\.[\w\-]+)*(\.[\w\-]{2,})$
 * Local part:
 *   - Starts with letter/number/`_`/`+`/`-`
 *   - Allows letters, numbers, `.`, `_`, `+`, `-`
 *   - Must not end with `.` and disallows consecutive dots and `!`
 * Domain:
 *   - One or more labels separated by dots
 *   - Each label starts/ends with alphanumeric and may contain `-` inside
 *   - Final TLD must be at least 2 letters
 */
export const emailRegex =
    /^(?!.*\.\.)(?!.*!)(?=[^@]*[A-Za-z0-9][^@]*@)[A-Za-z0-9_+-](?:[A-Za-z0-9._+-]*[A-Za-z0-9_+-])?@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export const passwordRules = /^[\s\S]{8,}$/;

export const JPFurigana = /^[\u3040-\u309F\u30A0-\u30FF]+$/;

export const fullNameParser = /(\S+)/g;

// VAT number regex
export const vatNumberPL = /^(PL)[0-9]{10}$/;
export const vatNumberPT = /^[0-9]{9}$/;
